import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './layout/PublicLayout.css'; // Build shared public layout styles
import LoginPanel from './features/login/LoginPanel';
import ChatPanel from './features/chat/ChatPanel';
import CreateUserPage from './features/user/CreateUserPage';
import AvatarGeneratorPage from './features/avatar/AvatarGeneratorPage';
import AvatarGalleryPage from './pages/AvatarGalleryPage';
import GuessAvatarEntryPage from './features/guess-avatar/GuessAvatarEntryPage';
import GuessAvatarRoomPage from './features/guess-avatar/GuessAvatarRoomPage';
import MainLayout from './layout/MainLayout';
import HomePage from './pages/HomePage'; // Import new HomePage
import { clearTokens } from './services/authService';
import websocketService from './services/websocketService';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userId = localStorage.getItem('user_id');
    if (userId) {
      setIsLoggedIn(true);
    }
    setIsLoading(false);
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    clearTokens();
    websocketService.disconnect();
    setIsLoggedIn(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      
      <Route path="/login" element={
        isLoggedIn ? <Navigate to="/create-user" replace /> : <div className="App"><header className="App-header"><LoginPanel onLoginSuccess={handleLoginSuccess} /></header></div>
      } />
      
      {/* 根路径显示主页 (包含 Avatar Playground) */}
      <Route path="/" element={<HomePage />} />
      
      {/* 公开路由：无需登录即可访问 */}
      <Route path="/avatar-generator" element={
         <div className="public-page-layout">
            <header className="public-page-header">
               <div className="header-logo" onClick={() => window.location.href=`${process.env.PUBLIC_URL}/`}>WebSocket Portal</div>
               {localStorage.getItem('user_id') ? (
                  <div className="header-actions">
                    <span className="header-greeting">Hi, <strong>{localStorage.getItem('user_id')}</strong></span>

                    <button className="btn-console" onClick={() => window.location.href=`${process.env.PUBLIC_URL}/create-user`}>
                      进入控制台 ➡️
                    </button>

                    <button className="btn-nav-danger" onClick={() => {
                        clearTokens();
                        window.location.reload();
                    }}>退出</button>
                  </div>
               ) : (
                  <button className="btn-nav-primary" onClick={() => window.location.href=`${process.env.PUBLIC_URL}/login`}>登录</button>
               )}
            </header>
            <div className="public-page-content">
               <div className="content-container">
                  <AvatarGeneratorPage />
               </div>
            </div>
         </div>
      } />

      {/* Avatar Gallery 路由 */}
      <Route path="/avatar-gallery" element={
         <div className="public-page-layout">
            <header className="public-page-header">
               <div className="header-logo" onClick={() => window.location.href=`${process.env.PUBLIC_URL}/`}>WebSocket Portal</div>
               {localStorage.getItem('user_id') ? (
                  <div className="header-actions">
                    <span className="header-greeting">Hi, <strong>{localStorage.getItem('user_id')}</strong></span>

                    <button className="btn-console" onClick={() => window.location.href=`${process.env.PUBLIC_URL}/create-user`}>
                      进入控制台 ➡️
                    </button>

                    <button className="btn-nav-danger" onClick={() => {
                        clearTokens();
                        window.location.reload();
                    }}>退出</button>
                  </div>
               ) : (
                  <button className="btn-nav-primary" onClick={() => window.location.href=`${process.env.PUBLIC_URL}/login`}>登录</button>
               )}
            </header>
            <div className="public-page-content">
               <div className="content-container">
                  <AvatarGalleryPage />
               </div>
            </div>
         </div>
      } />

      {/* 需要登录的布局路由 */}
      <Route element={isLoggedIn ? <MainLayout onLogout={handleLogout} /> : <Navigate to="/login" replace />}>
        {/* 这个 Route 没有 path，作为 Layout 的包装器 */}
        <Route path="/create-user" element={<CreateUserPage />} />
        <Route path="/web-chat" element={
          <div className="content-card" style={{ height: '100%', background: 'white', borderRadius: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
            <ChatPanel />
          </div>
        } />
        <Route path="/guess-avatar" element={<GuessAvatarEntryPage />} />
        <Route path="/guess-avatar/room/:roomId" element={<GuessAvatarRoomPage />} />
        {/* 如果需要登录后也在菜单里访问 Avatar，可以保留，或者指向同一个组件 */}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
